import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Icon, Text } from '../../Atoms';
import * as Styles from './index.styles';

const { StyledCopyToClipboard } = Styles;

export const CopyToClipboard = ({ bindTo, text, popoverIcon, popoverText }) => {
    const [copied, setCopied] = useState(false);

    const onCopy = () => {
        try {
            navigator.clipboard.writeText(text);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        } catch (error) {
            /* istanbul ignore next */
            window.console.log(error.message);
        }
    };

    useEffect(() => {
        let element;
        element = document.getElementById(bindTo);
        if (element) {
            element.addEventListener('click', onCopy);
        }

        return () => {
            element = document.getElementById(bindTo);
            if (element) {
                /* istanbul ignore next */
                element.removeEventListener('click', onCopy);
            }
        };
    }, [bindTo]);

    return (
        <StyledCopyToClipboard bindTo={bindTo} open={copied} onClose={() => setCopied(false)}>
            <Text>
                <Icon icon={['fal', popoverIcon]} size="lg" />
                {popoverText}
            </Text>
        </StyledCopyToClipboard>
    );
};

CopyToClipboard.propTypes = {
    bindTo: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    popoverIcon: PropTypes.string,
    popoverText: PropTypes.string,
};

CopyToClipboard.defaultProps = {
    popoverIcon: 'copy',
    popoverText: 'copiado',
};

CopyToClipboard.Styles = Styles;
